<template>
  <div :class="['input-group',{ 'icon-valid': valid }, { 'icon-error': error }]" >
    <input
      id="nome"
      name="nome"
      class="base-input"
      type="tel"
      placeholder="(DD) 00000 - 0000"
      v-mask="stringMask"
      :value="value"
      @input="handleInput"
      @blur="enviaGA()"
      ref="input"
      autocomplete="off"
      v-bind="$attrs"
      >
  </div>
</template>
<script>


import debounce from 'lodash.debounce';

export default {
  data() {
    return {

    }
  },
  methods:{
    enviaGA() {
      if(this.valid){
        const pathLocation = window.location.pathname.replaceAll("/", "")
        dataLayer.push({
          event: 'customEvent',
          eventCategory: `blog: ${pathLocation}`,
          eventAction: 'preencheu:calculadora-custo-cnpj',
          eventLabel: `telefone`
        })
      }
    },
  },
  props: {
    debounceTime: {
      type: Number,
      default: 0,
    },
    parse: {
      type: Function,
      default: value => value,
    },
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    stringMask:{
      type: String,
      default: ''
    },
  },
  computed: {
    handleInput() {
      return debounce((event) => {
        if (event.target) {
          this.$emit('input', this.parse(event.target.value));
        }
      }, this.debounceTime);
    },
  }

}
</script>
<style lang="scss" src="./style.scss" scoped></style>
